'use client';

import React, { createContext, useContext, type PropsWithChildren } from 'react';

import { MovieLandingPageConfiguration } from '@cineamo/api/models/premium-movie-landing-page-configuration/PremiumMovieLandingPageConfigurationDto';

export const DomainConfigurationContext = createContext<MovieLandingPageConfiguration | undefined>(undefined);

export const DomainConfigurationProvider: React.FC<
    PropsWithChildren<{ domainConfiguration: MovieLandingPageConfiguration }>
> = ({ children, domainConfiguration }) => {
    return (
        <DomainConfigurationContext.Provider value={domainConfiguration}>
            {children}
        </DomainConfigurationContext.Provider>
    );
};

export const useDomainConfiguration = (): MovieLandingPageConfiguration => {
    const context = useContext(DomainConfigurationContext);
    if (context === undefined) {
        throw new Error('useDomainConfiguration must be used within a DomainConfigurationProvider');
    }
    return context;
};
